import React, {
  ReactElement,
} from 'react';
import Button from '@mui/material/Button';



export const OpenReservationCell = ({
  props,
                                      openReservation,
}: {
  props: any;
  openReservation: () => void;
}): ReactElement => {
  return (
    <Button
      variant="text"
      onClick={(event) => {
        openReservation();
      }}
    >
      Select
    </Button>
  );
};
